import {
    RiTimeLine,
    RiCheckLine,
    RiPrinterLine,
    RiTruckLine,
    RiCheckDoubleLine,
} from 'react-icons/ri'
import styles from './OrderProgressBar.module.css'

interface OrderProgressBarProps {
    status: string
    compact?: boolean
}

interface Step {
    key: string
    label: string
    icon: React.ElementType
}

const STEPS: Step[] = [
    { key: 'pending',   label: 'Pendiente',  icon: RiTimeLine        },
    { key: 'confirmed', label: 'Confirmado', icon: RiCheckLine       },
    { key: 'printing',  label: 'Impresión',  icon: RiPrinterLine     },
    { key: 'shipped',   label: 'Enviado',    icon: RiTruckLine       },
    { key: 'delivered', label: 'Entregado',  icon: RiCheckDoubleLine },
]

export function OrderProgressBar({ status, compact = false }: OrderProgressBarProps) {
    const isCancelled = status === 'cancelled'
    const currentIndex = STEPS.findIndex((s) => s.key === status)

    function getStepClass(index: number): string {
        if (isCancelled && index === currentIndex) return styles.cancelled
        if (index < currentIndex) return styles.completed
        if (index === currentIndex) return styles.active
        return styles.pending
    }

    function getConnectorClass(index: number): string {
        if (index < currentIndex) return styles.connectorCompleted
        return ''
    }

    return (
        <div className={`${styles.progressBar} ${compact ? styles.compact : ''}`}>
            {STEPS.map((step, index) => {
                const Icon = step.icon
                return (
                    <div key={step.key} className={`${styles.step} ${getStepClass(index)}`}>
                        {index < STEPS.length - 1 && (
                            <div className={`${styles.connector} ${getConnectorClass(index)}`} />
                        )}
                        <div className={styles.stepIcon}>
                            <Icon />
                        </div>
                        <span className={styles.stepLabel}>{step.label}</span>
                    </div>
                )
            })}
        </div>
    )
}
